<template>
<div :class="this.userData.organization">
<nav class="navbar navbar-top navbar-expand navbar-dashboard navbar-dark dark_blue_bg ps-4 pe-4">
    <div class="container-fluid px-0">
      <div class="d-flex justify-content-between w-100" id="navbarSupportedContent">
        <a class="d-lg-none btn btn-lg btn-link top-level-nav-index" type="button" data-bs-toggle="collapse"
          data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false"
          aria-label="Toggle navigation">
          <div class="fas fa-bars fa-2x text-white"></div>
        </a>
        <div class="d-flex align-items-center navbar-element-m">
          <a class="navbar-brand" v-on:click="returnHome">
          <img :src="imagelogo" class="img-fluid top-logo" /></a>
        </div>
        <ul class="navbar-nav align-items-center top-level-nav-index">
          <!-- start notification  -->
          <li class="nav-item dropdown d-none">
            <a class="nav-link text-dark notification-bell dropdown-toggle" data-unread-notifications="false" href="#" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
              <div class="fas fa-bell fa-2x text-white"></div>
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-center mt-2 py-0">
              <div id="usernotif" class="list-group list-group-flush">
                <a href="#" class="text-center text-primary fw-bold border-bottom border-light py-3">Notifications</a>
              </div>
            </div>
          </li>
          <!-- end notification -->
          <!-- start support -->
          <li class="nav-item dropdown">
            <a class="nav-link text-dark notification-bell dropdown-toggle" data-unread-notifications="false" href="#" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
              <div class="fas fa-question-circle fa-2x text-white"></div>
            </a>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-center mt-2 py-0">
              <a class="dropdown-item d-flex align-items-center" v-on:click="support">Submit Support Ticket</a>
              <a class="dropdown-item d-flex align-items-center" v-on:click="recentactivity">View Recent Activity</a>
            </div>
          </li>
          <!-- end support -->
          <!-- start new -->
          <li class="nav-item dropdown" v-if="this.configscripts.length">
            <a class="nav-link text-dark notification-bell dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <div class="fas fa-tools fa-2x text-white"></div>
            </a>
            <div class="dropdown-menu dashboard-dropdown dropdown-menu-end mt-2 py-1">
              <a class="dropdown-item d-flex align-items-center" v-for='script in configscripts' @click="openModal({view: 'ModalConfigScripts', dt: script.value})">{{script.name}}</a>
              
              <!-- a class="dropdown-item d-flex align-items-center" @click="openModal({view: 'ModalConfigMergeData', dt: ''})">Merge Datasets</a -->
              <div class="dropdown-divider"></div>
              <a class="dropdown-item d-flex align-items-center" v-on:click="scriptresults">Results</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item d-flex align-items-center" v-on:click="modalconfigedit" v-if="this.userStatus == 'active'">Configure</a>
            </div>
          </li>
          <!-- end new -->
          <li class="nav-item dropdown">
            <a class="nav-link text-dark notification-bell dropdown-toggle" href="#" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <div class="fas fa-user fa-2x text-white"></div>
            </a>
            <div class="dropdown-menu dashboard-dropdown dropdown-menu-end mt-2 py-1">
              <a class="dropdown-item d-flex align-items-center" v-on:click="account">Account Info</a>
              <a class="dropdown-item d-flex align-items-center" @click="openModal({view: 'UpdatePasswordDialog', dt: ''})">Change Password</a>
              <!-- a class="dropdown-item d-flex align-items-center" href="#!">Activity Log</a -->
              <div class="dropdown-divider"></div>
              <a class="dropdown-item d-flex align-items-center" href="/"><svg class="dropdown-icon text-danger me-2"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                  </path>
                </svg>
                Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- start main container area -->
  <div class="container-fluid contain-content h-100">
    <div class="row g-0 h-100">
      <div class="col-lg-3" v-if="this.showSidebar">
        <!-- start sidebar -->
        <!-- {% include 'includes/sidebar.html' %} -->

        <nav id="sidebarMenu" class="sidebar d-lg-block sidebar-grey-bg collapse" data-simplebar>
          <div class="sidebar-inner px-2 pt-2" id="sidebarinnerNav">
            <div class="user-card d-flex d-lg-none flex-row-reverse pb-4">

              <div class="collapse-close d-lg-none">
                <a href="#sidebarMenu" data-bs-toggle="collapse" data-bs-target="#sidebarMenu"
                  aria-controls="sidebarMenu" aria-expanded="true" aria-label="Toggle navigation">
                  <svg class="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"></path>
                  </svg>
                </a>
              </div>
            </div>
            <ul id="sidenav-menu" class="nav flex-column pt-3 pt-md-0">
              <li class="sb-sidenav-menu-heading">Home</li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="returnDash">
                  <span class="sidebar-icon">
                    <div class="fas fa-home"></div>
                  </span>
                  <span class="sidebar-text">Dashboard</span>
                </a>
              </li>
              <li class="nav-item" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="userslist">
                  <span class="sidebar-icon">
                    <div class="fas fa-users"></div>
                  </span>
                  <span class="sidebar-text">Users</span>
                </a>
              </li>
              <li class="nav-item" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="userreport">
                  <span class="sidebar-icon">
                    <div class="fas fa-users"></div>
                  </span>
                  <span class="sidebar-text">User Report</span>
                </a>
              </li>
              <!-- li class="nav-item" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="activitylog">
                  <span class="sidebar-icon">
                    <div class="fas fa-list"></div>
                  </span>
                  <span class="sidebar-text">User Activity Log</span>
                </a>
              </li -->
              <li class="nav-item" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="smtptest">
                  <span class="sidebar-icon">
                    <div class="fas fa-envelope"></div>
                  </span>
                  <span class="sidebar-text">Send Email (Admin)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="clusterexplorer">
                  <span class="sidebar-icon">
                    <div class="fas fa-flag-usa"></div>
                  </span>
                  <span class="sidebar-text">Explore American Lifestyles</span>
                </a>
              </li>
              <li class="sb-sidenav-menu-heading">My Projects</li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="projects">
                  <span class="sidebar-icon">
                    <div class="fas fa-diagram-project"></div>
                  </span>
                  <span class="sidebar-text">Projects <div class="badge bg-light text-dark border border-primary" style="color: #000;">BETA</div></span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link side-nav-link"  v-on:click="datasets"> 
                  <span class="sidebar-icon">
                    <div class="fas fa-database"></div>
                  </span>
                  <span class="sidebar-text">Datasets</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="reports">
                  <span class="sidebar-icon">
                    <div class="fas fa-chart-line"></div>
                  </span>
                  <span class="sidebar-text">Reports</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="prospects">
                  <span class="sidebar-icon">
                    <div class="fas fa-users"></div>
                  </span>
                  <span class="sidebar-text">Prospects</span>
                </a>
              </li>
              <li class="nav-item" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="idealab">
                  <span class="sidebar-icon">
                    <div class="fa-solid fa-chart-bar"></div>
                  </span>
                  <span class="sidebar-text">Idea Lab <div class="badge bg-light text-dark border border-primary" style="color: #000;">BETA</div></span>
                </a>
              </li>
              <li class="nav-item d-none" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="marketresearchbusinesses">
                  <span class="sidebar-icon">
                    <div class="fa-solid fa-chart-bar"></div>
                  </span>
                  <span class="sidebar-text">Business Data Search</span>
                </a>
              </li>
              <li class="nav-item d-none" v-if="this.isAdmin">
                <a class="nav-link side-nav-link" v-on:click="marketresearch">
                  <span class="sidebar-icon">
                    <div class="fa-solid fa-chart-pie"></div>
                  </span>
                  <span class="sidebar-text">Market Research</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="emailappendbulk">
                  <span class="sidebar-icon">
                    <div class="fas fa-mail-bulk"></div>
                  </span>
                  <span class="sidebar-text">Email Append Service</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link side-nav-link" v-on:click="aiassistanttemplate">
                  <span class="sidebar-icon">
                    <div class="fas fa-comment"></div>
                  </span>
                  <span class="sidebar-text">AI Assistant</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <!-- end sidebar -->
      </div>
      <div :class="columnClass">
        <main class="content">
          <!-- dynamic area -->
          <div class="alert-primary text-center" id="alertmsgbox"></div>
          <div id="innerapp">
              <component 
                v-bind:is="component" 
                @custom-change="customChange"
                @custom-change-project="customChangeProject"
                @custom-change-append="customChangeAppend"
                @custom-prospect-ai="customProspectAi" 
                @custom-change-geospatial="customChangeGeospatial"
                @purchase-items="purchaseItems" 
                @purchase-email="purchaseEmail"
                @free-items="freeItems"
                v-bind:productTitle="productTitle" 
                v-bind:productPrice="productPrice" 
                v-bind:productSku="productSku"
                v-bind:thisMode="thisMode"
                v-bind:ProdCredits="ProdCredits"
                v-bind:thisRemaining="thisRemaining" 
                v-bind:thisProspectRemain="thisProspectRemain" 
                v-bind:thisSubscription="thisSubscription" 
                v-bind:showSidebar="showSidebar"
                @toggle-nav="toggleNav"
                @toggle-nav-show="toggleNavShow"
                @message-alert="messageAlert" 
                @open-modal="openModal"
                @deactivate-user="deactivateUser" 
                @activate-user="activateUser" 
                @check-user-email="checkUserEmail"
                @decrease-dataset-count="decreaseDatasetCount" 
                @decrease-prospect-count="decreaseProspectCount" 
                @decrease-email-count="decreaseEmailCount"
                @update-user-session-data="updateUserSessionData" 
                @created-session-id="createdSessionId"
                @lookup-user-info="lookupUserInfo"
                @lookup-subscription-list="lookupSubscriptionList"
                @fetch-events="fetchEvents"
                @test-subscription-type="testSubscriptionType"
                @update-user-role="updateUserRole"
                @kill-promocode="killPromocode"
                @log-event="logEvent"
                @active-email-append="activeEmailAppend"
                @set-append-file="setAppendFile"
                @import-src-data="importSrcData"
                @count-src-data="countSrcData"
                @generate-zip-list="generateZipList"
                @make-chat-true="makeChatTrue"
                @set-email-mashup="setEmailMashup"
                @delete-file="deleteFile"
                @delete-script="deleteScript"
                @force-rerender="forceRerender"
                v-bind:session-id="sessionId"
                v-bind:isAdmin="isAdmin" 
                v-bind:userStatus="userStatus" 
                v-bind:user-subscription="userSubscription"
                v-bind:passedData="passedData" 
                v-bind:passedNames="passedNames"
                v-bind:userData="userData" 
                v-bind:stripePk="stripePk"
                v-bind:confirm-hash="confirmHash"
                v-bind:promo-confirm="promoConfirm"
                v-bind:email-append-file="emailAppendFile"
                v-bind:emaillistsend="emaillistsend"
                v-bind:msg-items="msgItems"
                v-bind:has-chat="hasChat"
                v-bind:append-token="appendToken"
                v-bind:append-filename="appendFilename"
                v-bind:append-filepath="appendFilepath"
                v-bind:append-filerange="appendFilerange"
                v-bind:projectrefer="projectrefer"
              />
              <div>
                <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <component 
                          v-bind:is="modalcontent" 
                          @custom-change="customChange" 
                          @custom-change-append="customChangeAppend"
                          @custom-prospect-ai="customProspectAi" 
                          @custom-change-geospatial="customChangeGeospatial"
                          @message-alert="messageAlert" 
                          v-bind:passedModalData="passedModalData" 
                          v-bind:passedMashupSi="passedMashupSi" 
                          v-bind:passedMashupDv="passedMashupDv" 
                          v-bind:passedMashupBf="passedMashupBf" 
                          v-bind:passedMashupRf="passedMashupRf"
                          v-bind:passedMashupFt="passedMashupFt"
                          v-bind:passedMashupEr="passedMashupEr"
                          v-bind:userData="userData" 
                          v-bind:isAdmin="isAdmin"
                          v-bind:user-subscription="userSubscription"
                          @decrease-dataset-count="decreaseDatasetCount"
                          @update-user-session-data="updateUserSessionData" 
                          @process-address="processAddress"
                          @lookup-user-info="lookupUserInfo"
                          v-bind:thisSubscription="thisSubscription"
                          @close-modal="closeModal" 
                          @kill-promocode="killPromocode"
                          @open-modal="openModal" 
                          @set-mashup="setMashup"
                          @log-event="logEvent"
                          @delete-file="deleteFile"
                          @delete-script="deleteScript"
                          @force-rerender="forceRerender"
                          v-bind:append-token="appendToken"
                          v-bind:append-filename="appendFilename"
                          v-bind:append-filepath="appendFilepath"
                          v-bind:append-filerange="appendFilerange"
                          :key="componentKey"
                        />
                    </div>
                </div>
                <div v-if="active" class="modal-backdrop fade show"></div>
            </div>
          </div>
          <div class="d-none">
          <v-idle
            @idle="onidle"
            @remind="onremind"
            :loop="true"
            :reminders="[5, 10]"
            :wait="120"
            :duration="3600"
          />
          </div>
          <!-- end dynamic area -->
        </main>
        <footer class="footer-placed bg-white rounded shadow p-2 position-sticky bottom-0 end-0 z-2">
          <div class="row">
            <div class="col-sm">
              <p class="float-start text-left"><small>Copyright &copy; Analyze Corp. 2014-{{ new Date().getFullYear() }}</small></p>
            </div>
            <div class="col-sm">
              <p class="float-end text-right"><small><a href="https://www.analyzecorp.com/privacy-policy/" target="_blank">Privacy
                    Policy</a> . <a href="https://www.analyzecorp.com/terms-and-conditions/" target="_blank">Terms &amp; Conditions</a></small></p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from "vue-toastification";
import { useCookies } from "vue3-cookies";
import Dashboard from './views/Dashboard.vue';
import Datasets from './views/Datasets.vue';
import Projects from './views/Projects.vue';
import UserList from './views/UserList.vue';
import UserReport from './views/UserReport.vue';
// start map tester
import MapTester from './views/MapTester.vue';
// end map tester
// import UserActivityLog from './views/UserActivityLog.vue';
import SMTPTest from './views/SMTPTest.vue';
import Reports from './views/Reports.vue';
import Prospects from './views/Prospects.vue';
import ProspectsDashboard from './views/ProspectsDashboard.vue';
import ReportShell from './views/ReportShell.vue';
import DataShell from './views/DatasetShell.vue';
import RenameDatasetForm from "./views/modal/ModalRenameDatasetForm.vue";
import RenameProspect from "./views/ProspectRenameProspect.vue";
import ProspectCriteria from "./views/ProspectCriteria.vue";
import TransferDatasetForm from "./views/modal/ModalTransferDatasetForm.vue";
import DatsetUploadDialog from "./views/modal/ModalDatasetUploadDialog.vue";
import EmailAppend from './views/EmailAppend.vue';
import EmailUpload from "./views/modal/EmailUpload.vue";
import EmailAppendBulk from './views/EmailAppendBulk.vue';
import EmailUploadBulk from "./views/modal/EmailUploadBulk.vue";
import UpdatePasswordDialog from "./views/modal/ModalUpdatePasswordDialog.vue";
import AccountInfo from "./views/AccountInfo.vue";
import ModalConfigEditDialog from "./views/modal/ModalConfigEditDialog.vue";
import ModalConfigResults from "./views/modal/ModalConfigResults.vue";
import ModalConfigScripts from './views/modal/ModalConfigScripts.vue';
import MashupDialog from "./views/modal/ModalMashupDialog.vue";
import MashupEmailAppendDialog from "./views/modal/ModalEmailAppendMashupDialog.vue";
import MashupError from "./views/modal/MashupError.vue";
import AddProject from "./views/modal/ModalAddProject.vue";
import ProjectDetails from "./views/ProjectDetails.vue";
import EditAddress from "./views/modal/ModalEditAddress.vue";
import ModalEditUsersData from "./views/modal/ModalEditUsersData.vue";
import ModalEditUsersSession from "./views/modal/ModalEditUsersSession.vue";
import ModalEditScriptsData from "./views/modal/ModalEditScriptsData.vue";
import ModalDeleteDataset from "./views/modal/ModalDeleteDataset.vue";
import ModalDedupe from "./views/modal/ModalDedupe.vue";
import GenerateZipDataset from "./views/modal/ModalGenerateZipDataset.vue";
import AddGeospatialLocation from "./views/modal/AddGeospatialLocation.vue";
import RetrieveMapBoundaries from "./views/modal/RetrieveMapBoundaries.vue";
import PurchaseReport from "./views/cart/PurchaseReport.vue";
import PurchaseEmailCredits from "./views/cart/PurchaseEmailCredits.vue";
import SelectSubscription from "./views/cart/SelectSubscription.vue";
import SelectEmailAppend from "./views/cart/SelectEmailAppend.vue";
import MarketResearch from "./views/MarketResearch.vue";
import MarketResearchBusinesses from "./views/MarketResearchBusinesses.vue";
import IdeaLab from "./views/IdeaLab.vue";
import AIAssistant from "./views/AIAssistant.vue";
import ClusterExplorer from "./views/ClusterExplorer.vue";
import SupportForm from "./views/SupportForm.vue";
import RecentActivity from "./views/RecentActivity.vue";
// import SelectSubscriptionHalf from "./views/cart/SelectSubscriptionHalf.vue";
// import SelectSubscription from "./views/cart/SelectSubscriptionAlt.vue";
import CheckSessions from "./views/CheckSessions.vue";
import DashboardLoader from "./views/DashboardLoader.vue";
import ScriptsResults from "./views/ScriptsResults.vue";
import RenameScript from "./views/modal/RenameScript.vue";
import imagelogo from "../img/analyze/clientell_logo_light_inv.png"
export default {
  components: {
    Projects, 
    ProjectDetails,
    Datasets, 
    Reports, 
    Dashboard, 
    Prospects, 
    ProspectsDashboard, 
    ReportShell, 
    DataShell, 
    RenameDatasetForm, 
    TransferDatasetForm, 
    DatsetUploadDialog, 
    UpdatePasswordDialog, 
    AccountInfo, 
    SupportForm,
    ModalConfigResults,
    ModalConfigScripts,
    MashupDialog, 
    MashupEmailAppendDialog,
    MashupError, 
    AddProject, 
    RenameProspect, 
    ProspectCriteria, 
    EditAddress, 
    PurchaseReport, 
    PurchaseEmailCredits, 
    SelectSubscription, 
    SelectEmailAppend,
    CheckSessions, 
    DashboardLoader, 
    ModalDeleteDataset, 
    UserList, 
    MapTester,
    SMTPTest, 
    ModalConfigEditDialog,
    ModalEditUsersData, 
    ModalEditUsersSession, 
    ModalEditScriptsData,
    ModalDedupe,
    AddGeospatialLocation,
    RetrieveMapBoundaries,
    EmailAppend, 
    EmailUpload,
    EmailAppendBulk,
    EmailUploadBulk,
    MarketResearch,
    MarketResearchBusinesses,
    GenerateZipDataset,
    ScriptsResults,
    RenameScript,
    AIAssistant,
    ClusterExplorer
  },
  data() {
    return {
      imagelogo: imagelogo,
      component: DashboardLoader,
      modalcontent: RenameDatasetForm,
      isAdmin: false,
      passedData: 'Test Default',
      passedNames: [],
      passedModalData: 'Test Default',
      passedMashupSi: '',
      passedMashupDv: '',
      passedMashupBf: '',
      passedMashupRf: '',
      passedMashupEr: '',
      passedMashupFt: '',
      userData: [],
      userSubscription: [],
      activeEmailAppend: [],
      active: false,
      userStatus: 'inactive',
      productTitle: 'Test Default',
      productSku: 'Test Default',
      productPrice: 'Test Default',
      thisMode: 'Test Default',
      thisRemaining: 'Test Default',
      thisProspectRemain: 'Test Default',
      thisSubscription: 'Test Default',
      ProdCredits: '',
      stripePk: '',
      sessionId: '',
      // activityLogFull: '',
      confirmHash: '',
      promoConfirm: '',
      emailAppendFile: '',
      emaillistsend: [],
      configscripts: [],
      msgItems: [],
      hasChat: false,
      currenttick: '',
      bulkemailslist: [],
      disablescripts: false,
      componentKey: 0,
      projectrefer: '',
      showSidebar: true,
      columnClass: 'col-lg-9'
    }
  },
  setup() {
      const toast = useToast();
      const { cookies } = useCookies();
      return { cookies, toast }
  },
  computed: {
    nextyear() {
      const d = new Date()
      d.setDate(d.getDate() + 365)
      return d 
    }
  },
  methods: {
    forceRerender() {
      console.log('component key is '+this.componentKey);
      this.componentKey += 1;
      const currentComponent = this.component;
      this.component = null;
      this.$nextTick(() => {
        this.component = currentComponent;
      });
    },
    conditionalColumn() {
      console.log('conditional column '+this.showSidebar);
      if(this.showSidebar == true) {
        return 'col-lg-9';
      } else {
        return 'col';
      }
    },
    maptester() {
      this.component = MapTester;  
    },
    projects(){
      this.component = Projects;
    },
    userslist() {
      this.component = UserList;
    },
    userreport() {
      this.component = UserReport;
    },
    clusterexplorer() {
      this.component = ClusterExplorer;
    },
    modalconfigedit() {
      this.openModal({view: 'ModalConfigEditDialog', dt: ''});
      // this.component = ModalConfigEditDialog;
    },
    //activitylog() {
      //this.component = UserActivityLog;
    //},
    smtptest() {
      this.component = SMTPTest;
    },
    datasets(){
      this.component = Datasets;
      this.projectrefer = "";
    },
    reports(){
      this.component = Reports;
      this.projectrefer = "";
    },
    datashell(){
      this.component = DataShell;
      //this.projectrefer = "";
    },
    reportshell(){
      this.component = ReportShell;
      //this.projectrefer = "";
    },
    dashboard(){
      this.component = Dashboard;
    },
    prospects(){
      this.component = ProspectsDashboard;
    },
    account() {
      this.component = AccountInfo;
    },
    support() {
      this.component = SupportForm;
    },
    recentactivity() {
      this.component = RecentActivity;
    },
    renew() {
      this.component = SelectSubscription;
    },
    scriptresults() {
      this.component = ScriptsResults;
    },
    emailappend() {
      this.component = EmailAppend;
    },
    emailappendbulk() {
      this.component = EmailAppendBulk;
    },
    marketresearch() {
      this.component = MarketResearch;
    },
    idealab() {
      this.component = IdeaLab;
    },
    marketresearchbusinesses() {
      this.component = MarketResearchBusinesses;
    },
    aiassistanttemplate() {
      this.component = AIAssistant;
    },
    onidle() {
      this.messageAlert({alert: 'You are being logged out.', classel: 'warning'});
      window.location.href = '../';
    },
    makeChatTrue() {
      this.hasChat = true;
      console.log('has chat is now'+this.hasChat);
    },
    onremind(time) {
      this.messageAlert({alert: 'Due to inactivity, You will be logged out in '+time+' seconds.', classel: 'warning'});
    },
    setAppendFile({shell,dataset,filenamedata,emailist}) {
      this.component = shell;
      this.passedData = dataset;
      this.emailAppendFile = filenamedata;
      this.emaillistsend = emailist;
    },
    returnHome() {
      // console.log('return home: ' + this.userStatus);
      if(this.userStatus != 'active') {
        this.component = SelectSubscription;
      } else if(this.isAdmin === true) {
        // this.component = Projects;
        this.component = Dashboard;
      } else {
        this.component = Dashboard;
      }
    },
    returnDash() {
      if(this.userStatus != 'active') {
        this.component = SelectSubscription;
      } else {
        this.component = Dashboard;
      }
    },
    customChange({shell,dataset}) {
      this.component = shell;
      this.passedData = dataset;
      this.columnClass = 'col-lg-9';
    },
    customChangeProject({shell,dataset,project}) {
      this.component = shell;
      this.passedData = dataset;
      this.projectrefer = project;
    },
    customChangeGeospatial({shell,dataset}) {
      this.component = shell;
      this.passedData = dataset;
      this.columnClass = 'col';
    },
    resetBackBtn({referval}) {
      this.projectrefer = referval;
      console.log('test projectrefer data '+this.projectrefer);
    },
    toggleNav() {
      this.showSidebar = false;
      console.log('Nav Hidden');
    },
    toggleNavShow() {
      this.showSidebar = true;
      console.log('Nav Displayed');
    },
    customChangeAppend({dataset,range}) {
      this.component = EmailUploadBulk;
      this.appendFilerange = range;
      this.passedData = dataset;
      console.log('customChangeAppend values. filename/path: '+ this.passedData +'range: '+ this.appendFilerange);
    },
    customProspectAi({shell,dataset,names}) {
      this.component = shell;
      this.passedData = dataset;
      this.passedNames = names;
    },
    isDisable() {
      if(this.configscripts.length) {
        this.disablescripts = true;
      }
    },
    generateZipList() {
      axios.post('/mashup_from_zip')
        .then(
          (response) => {        
            console.log(response.data);
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
        console.error("There was an error in importing SRC data!", error);
      }); 
    },
    getCurrentChat() {
      // console.log('getting current chat');
      axios.get('/get_chat')
      .then(
        (response) => {
          if(response.data.length) {
            this.msgItems = response.data;
          }  
        }
      )
      .catch(
        (error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
        }
      );
    },
    getfirsttick() {
      this.currenttick;
      axios.get('/get_update_tick')
        .then(
          (response) => {        
            this.currenttick = response.data;
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
        console.error("There was an error in importing SRC data!", error);
      }); 

    },
    importSrcData() {
      //console.log('starting import data');
      axios.get('/import_src_data')
        .then(
          (response) => {        
            console.log(response.data);
            // console.log(JSON.stringify(response.data));
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
        console.error("There was an error in importing SRC data!", error);
      }); 
    },
    countSrcData({sentval}) {
      //console.log('starting count data'+JSON.stringify(sentval));
      let formData = new FormData();
      formData.append('vbr', sentval);
        axios.post('/count_src_data', formData).then(
          (response) => {        
            console.log(JSON.stringify(response.data));
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
        console.error("There was an error in importing SRC data!", error);
      }); 
    },
    deleteFile({filename,directory}) {
      let formData = new FormData();
      formData.append('filename', filename);
      formData.append('directory', directory);
      axios.post('/delete_a_file', formData)
      .then(
			(response) => {
        console.log('delete file complete '+JSON.stringify(response));
        this.forceRerender();
        this.messageAlert({alert: 'Deleting file: /'+directory+'/'+filename+'.', classel: 'info'});
      }).catch(error => {
        this.errorMessage = error.message;
        this.messageAlert({alert: 'There was an error!', classel: 'error'});
        console.error("There was an error!", error);
      });
    },
    deleteScript({filename,directory}) {
      let formData = new FormData();
      formData.append('filename', filename);
      formData.append('directory', directory);
      console.log('filename is '+filename+' directory is '+directory);
      axios.post('/delete_a_script', formData)
      .then(
			(response) => {
        console.log('delete file complete '+JSON.stringify(response));
        this.forceRerender();
        this.messageAlert({alert: 'Deleting file: /'+directory+'/'+filename+'.', classel: 'info'});
      }).catch(error => {
        this.errorMessage = error.message;
        this.messageAlert({alert: 'There was an error!', classel: 'error'});
        console.error("There was an error!", error);
      });
    },
    configscriptlist() {
      //console.log('start process');
      axios.post('/script_list')
        .then(
          (response) => {  
            var curArray = response.data;
            var tempArr = [];
            curArray.forEach(function (item, index) {
              tempArr.push({ value: item[0], name: item[1], description: item[2] });
            });
            this.configscripts = tempArr;
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
          console.error("There was an error", error);
      }); 
    },
    configcompletescript() {
      axios.post('/script_complete')
        .then(
          (response) => {        
            console.log(response.data);
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
          console.error("There was an error", error);
      }); 
    },
    configresults() {
      axios.post('/script_results')
        .then(
          (response) => {        
            console.log(response.data);
          })
        .catch(
          (error) => {
          this.errorMessage = error.message;
          console.error("There was an error", error);
      }); 
    },
    freeItems({title,price,sku,mode,remaining,prospects,subscription}) {
      this.productTitle = title;
      this.productPrice = price;
      this.productSku = sku;
      this.thisMode = mode;
      this.thisRemaining = remaining;
      this.thisProspectRemain = prospects;
      this.thisSubscription = subscription;
      var email = this.userSubscription.email;
      var curdate = new Date().toLocaleString();
      var expiration_date = this.nextyear.toLocaleString();
      axios.get('/update_user_status', { params: {subscription: subscription, current_start: curdate, current_expire: expiration_date, remaining_dataset: remaining, remaining_prospect: prospects, email:email} })
      .then(
          (response) => {
              this.userSubscription = JSON.stringify(response.data);
              axios.get('/confirm_initial_login')
              .then(
                (response) => {
                  this.confirmHash = response.data;
                  this.successURL = window.location.protocol+'//'+window.location.hostname+'/authenticate?username='+this.userData.user+'&confirm='+this.confirmHash;
                  window.location.href = this.successURL;
              })
              .catch(
                (error) => {
                  this.errorMessage = error.message;
                  console.error("There was an error in CONFIRM INITIAL LOGIN REGUEST!", error);
              }); 
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    },
    purchaseItems({title,price,sku,mode,remaining,prospects,subscription}) {
      this.productTitle = title;
      this.productPrice = price;
      this.productSku = sku;
      this.thisMode = mode;
      this.thisRemaining = remaining;
      this.thisProspectRemain = prospects;
      this.thisSubscription = subscription;
      var email = this.userSubscription.email;
      var curdate = new Date().toLocaleString();
      var expiration_date = this.nextyear.toLocaleString();
      axios.get('/update_user_status', { params: {subscription: subscription, current_start: curdate, current_expire: expiration_date, remaining_dataset: remaining, remaining_prospect: prospects, email: email} })
      .then(
          (response) => {
              this.userSubscription = JSON.stringify(response.data);
              console.log('UPDATE USER STATUS SUCCESS. Response data: '+this.userSubscription);
              this.component = PurchaseReport;
              // this.messageAlert({alert: 'UPDATE USER STATUS SUCCESS.', classel: 'success'});
              // console.log('submitted! well its commented out for now to halt redirection to stripe');
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    },
    purchaseEmail({title,price,sku,mode,credits}) {
      this.productTitle = title;
      this.productPrice = price;
      this.productSku = sku;
      this.thisMode = mode;
      this.ProdCredits = credits
      this.component = PurchaseEmailCredits;
    },
    updateStatus({newstat}) {
      this.userStatus = newstat;
    },
    openModal({view,dt}) {
        this.modalcontent = view;
        this.passedModalData = dt;
        const body = document.querySelector("body")
        this.active = !this.active
        this.active ? body.classList.add("modal-open") : body.classList.remove("modal-open")
    },
    closeModal() {
      const body = document.querySelector("body")
      this.active = !this.active
      this.active ? body.classList.add("modal-open") : body.classList.remove("modal-open")
      this.modalcontent = RenameDatasetForm
      this.passedModalData = 'Test Default'
    },
    killPromocode() {
        var date = new Date();
        date.setDate(date.getDate() - 1);
        this.cookies.set("ClientellPROMO", "null", date);
    },
    setMashup({si,dv,bf,rf,ft,er}) {
        this.passedMashupSi = si;
        this.passedMashupDv = dv;
        this.passedMashupBf = bf;
        this.passedMashupRf = rf;
        this.passedMashupFt = ft;
        this.passedMashupEr = er;
        // console.log('test mashup response: '+si+', '+dv+', '+bf+', '+rf+', '+ft+', '+er);
        if(this.passedMashupEr == 'success') {
          this.modalcontent = MashupDialog;
        } else {
          this.modalcontent = MashupError;
        }
        const body = document.querySelector("body")
        this.active = !this.active
        this.active ? body.classList.add("modal-open") : body.classList.remove("modal-open")
    },
    setEmailMashup({si,dv,rf,ft,er}) {
        this.passedMashupSi = si;
        this.passedMashupDv = dv;
        this.passedMashupRf = rf;
        this.passedMashupFt = ft;
        this.passedMashupEr = er;
        if(this.passedMashupEr == 'success') {
          this.modalcontent = MashupEmailAppendDialog;
        } else {
          this.modalcontent = MashupError;
        }
        const body = document.querySelector("body")
        this.active = !this.active
        this.active ? body.classList.add("modal-open") : body.classList.remove("modal-open")

    },
    messageAlert({alert,classel}) {
      if(classel == 'success') {
        this.toast.success(alert, {
        timeout: 12000
      });
      } else if (classel == 'error') {
        this.toast.error(alert, {
        timeout: 12000
      });
      } else if (classel == 'warning') {
        this.toast.warning(alert, {
        timeout: 12000
      });
      } else {
        this.toast.info(alert, {
        timeout: 12000
      });
      }
    },
    addyear({oldyear}) {
      const d = new Date(oldyear)
      d.setDate(d.getDate() + 365)
      return d 
    },
    decreaseDatasetCount() {
      axios({
            method : 'POST',
            url : '/decrease_session_dataset',
            data:'',
        }).then(
            (response) => {
			      // console.log('new count is: '+JSON.stringify(response.data));
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    },
    decreaseProspectCount() {
      axios({
            method : 'POST',
            url : '/decrease_session_prospects',
            data:'',
        }).then(
            (response) => {
			      // console.log('new count is: '+JSON.stringify(response.data));
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    },
    decreaseEmailCount(emailcount) {
      let formData = new FormData();
      formData.append('emailcount', emailcount);
      // console.log('decrease email count test: '+emailcount);
       axios({
            method : 'POST',
            url : '/decrease_session_email',
            data:formData,
        }).then(
            (response) => {
			      // console.log('email deduction response: '+JSON.stringify(response.data));
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    },
    activateUser({status}) {
        axios({
            method : 'POST',
            url : '/activate_user_status',
            data:'',
        }).then(
            (response) => {
			      this.userStatus = response.data;
            if(this.userStatus == 'active') {
              this.component = Dashboard;
            } else {
              this.component = SelectSubscription;
            }
        })
        .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
        // console.log('session status: ' + this.status);
    },
    deactivateUser({status}) {
      axios({
            method : 'POST',
            url : '/deactivate_user_status',
            data:'',
        }).then(
            (response) => {
			      this.userStatus = response.data;
            if(this.userStatus == 'active') {
              this.component = Dashboard;
            } else {
              this.component = SelectSubscription;
            }
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
    },
    updateUserSubscriptionDates({newdate}) {
      var initialDate = new Date(newdate)
      var curdate = initialDate.toLocaleString();
      var altEnd = this.addyear({oldyear:newdate});
      console.log('Updated Sub Start: '+newdate);
      console.log('Updated Sub End (alt): '+altEnd);
      console.log('Updated Sub End (alt local string): '+altEnd.toLocaleString());
      axios.get('/update_user_dates', { params: {new_start: newdate , new_expire: altEnd.toLocaleString()}})
      .then(
            (response) => {
			      console.log(response.data);
        })
        .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
    },
    async lookupSubscriptionList() {
      console.log('test customer id before looking up subscription: '+this.userSubscription.customer_id);
      axios.get('/check_user_subscription', {params: {customer_id : this.userSubscription.customer_id}})
      .then(
          (response) => {
            var customer_current_id = response.data.data[0].customer;
            var customer_current_status = response.data.data[0].plan.active;
            var customer_current_start = response.data.data[0].start_date;
            var customer_current_plan = response.data.data[0].plan.id;
            var converted_date = new Date(customer_current_start * 1000);
            var converted_start_date = new Intl.DateTimeFormat('default', {dateStyle: 'long'}).format(converted_date);
            var date1 = new Date(this.userSubscription.current_start).toLocaleString();
            var date2 = new Date(converted_start_date).toLocaleString();
            console.log('Session start date: '+date1);
            console.log('Stripe start date: '+date2);
            if(date1 !=  date2){
                this.updateUserSubscriptionDates({newdate: date2});
                console.log('the dates are not equal');
            };
            if(customer_current_status) {
              if(this.userSubscription.status != 'active') {
                console.log('test 2 is INACTIVE');
                this.activateUser({status: 'active'});
                console.log('activated user');
                this.component = Dashboard;
              }
            };
            if(!customer_current_status) {
              if(this.userSubscription.status == 'active') {
                this.deactivateUser({status: 'inactive'});
                console.log('deactivated user');
                this.component = SelectSubscription;
              }
            };
          }
        )
        .catch(
          (error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            }
        );
    },
    lookupUserInfo() {
      axios.get('/user_info', { params: {dataset: 'test'} })
      .then(
        (response) => {
          this.userData = response.data;
          // console.log('User Info '+JSON.stringify(response.data));
          if( this.userData.roles.match(new RegExp("(?:^|,)Administrator(?:,|$)"))) {
            this.isAdmin = true;
            this.component = Dashboard;
          }
        }
      )
      .catch(
        (error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          }
      )
    },
    updateUserSessionData() {
      axios.post('/user_subscription', {})
        .then(
          (response) => {
            this.userSubscription = response.data;
            // console.log('user subscription is:'+JSON.stringify(this.userSubscription));
            // console.log('subscription '+this.userSubscription.subscription);
            let expdate = this.userSubscription.current_expire;
            let expdateNew = new Date(expdate)
            let currentDate = new Date();
            // console.log('test date '+this.userSubscription.current_start);
            if(this.userSubscription.customer_id == 'not set') {
              this.checkUserEmail();
              console.log('customer id lookup');
              this.logEvent({clss: 'success' , alrt: 'customer id lookup', res: this.userSubscription})
            };
             if(this.userSubscription.status != 'active' && this.userSubscription.subscription != 'single') {
              this.lookupSubscriptionList();
              console.log('inactive state detected, looking up subscription');
              this.logEvent({clss: 'success' , alrt: 'inactive state detected, looking up subscription', res: this.userSubscription})
            };
            if(this.userSubscription.subscription != 'single' && expdateNew < currentDate) {
              this.deactivateUser({status: 'inactive'});
              console.log('subscription expired');
              this.logEvent({clss: 'success' , alrt: 'subscription expired', res: this.userSubscription})
            };
            
          }
        )
        .catch(
          (error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            this.logEvent({clss: 'fail' , alrt: 'subscription error', res: this.errorMessage})
            }
        );
    },
    createdSessionId({prodkey,prodmode,conhash}) {
      // might need to delete this function (it is no longer called on because of issues 'purchasereport' template) - make sure to also remove v:bind sessionId and @created-session-id and references
      console.log('creating session ID');
      axios.get('/create_checkout_session', { params: {productkey: prodkey, producttype: prodmode, username: this.userData.user, confirm: conhash } })
      .then(
        (response) => {
          // console.log('session id is'+JSON.stringify(response.data.sessionId));
          // this.cookies.set("sessionRecall", response.data.sessionId);
          this.sessionId = JSON.stringify(response.data.sessionId);
          this.logEvent({clss: 'success' , alrt: 'Session ID Created.', res: response.data.sessionId})
          // console.log('updated session ID value '+ this.sessionId);
        })
        .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            this.logEvent({clss: 'fail' , alrt: 'Session ID Failed.', res: this.errorMessage})
        });
    },
    onServerSideUpdateTimer() {
      axios.get('/update_needed', { params: {extended: 'True', last_tick: this.currenttick}})
      .then(
        (response) => {
          var initResponse = response.data;
          this.currenttick = initResponse.tick;
          if(initResponse.updates != '' && typeof initResponse.updates != 'undefined' && initResponse.updates != []) {
            for (var i = 0; i < response.data.updates.length; i++) {
              if(response.data.updates[i].short_msg.includes('ERR')) {
                var finclass = 'error';
              } else {
                var finclass = 'success';
              };

              this.messageAlert({alert: JSON.stringify(response.data.updates[i].long_msg), classel: finclass});
              //this.logEvent({clss: finclass, alrt: JSON.stringify(response.data.updates[i].long_msg), res: JSON.stringify(response.data.updates[i])})
              // refresh page IF current page is a list of the current job
              if(this.component == 'Datasets' && response.data.updates[i].short_msg.includes('RPT_DONE')) {
                console.log('front end detected dataset upload job is complete');
                this.forceRerender();
                //this.datasets();
              } else if(this.component == 'ProspectsDashboard' && response.data.updates[i].short_msg.includes('PROSPECTS_DONE')) {
                console.log('front end detected prospect job is complete');
                this.forceRerender();
                //this.prospects();
              };
              if(this.component == 'Dashboard') {
                console.log('front end detected dashboard is currently set');
              }
            }
          }
        }
      )
      .catch(
        (error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.messageAlert({alert: 'There was an error!', classel: 'error'});
          this.logEvent({clss: 'fail' , alrt: 'Serverside Timer failed ', res: this.errorMessage})
          window.location.href = '../';
          }
      );
    },
    checkUserEmail() {
      axios.get('/check_customer_email', { params: {useremail: this.userData.email} })
      .then(
        (response) => {
          //console.log('check user email response '+response.data)
          this.logEvent({clss: 'success' , alrt: 'check user email response success ', res: response.data})
        }
      )
      .catch(
        (error) => {
          this.errorMessage = error.message;
          //console.error("There was an error!", error);
          this.logEvent({clss: 'fail' , alrt: 'check user email response failed ', res: this.errorMessage})
          this.messageAlert({alert: 'There was an error retriving Customer Data from Email', classel: 'error'})
          }
      )
    },
    updateUserRole(updateuid) {
      // console.log('Make admin selected');
       // axios.get('/make_admin', { params: {theuid: updateuid}})
       axios.get('/toggle_admin', { params: {theuid: updateuid}})
        .then(
          (response) => {
            //console.log('Make admin success');
            //this.logEvent({clss: 'success' , alrt: 'Make admin success', res: response.data})
            console.log(response.data);
          }
        )
        .catch(
        (error) => {
          this.errorMessage = error.message;
          this.logEvent({clss: 'fail' , alrt: 'Make admin failure', res: error.message})
          console.error("There was an error!", error);
          // this.messageAlert({alert: 'There was an error updating Customer Roles', classel: 'error'})
          }
      )
    },
    testSubscriptionType() {
      axios.get('/test_subscription_type', { params: {} })
      .then(
        (response) => {
          console.log('TEST user subscription lookup '+response.data)
        }
      )
      .catch(
        (error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          }
      )
    },
    logEvent({clss,alrt,res}) {
      // console.log('the class: ' + clss + ' alert: ' + alrt + ' response: ' + res);
      var currentDateTime = new Date().toLocaleString();
      console.log('logging event: '+ this.userData.name + ' Current Date time: ' + currentDateTime);
      axios.get('/log_user_event', {params: {classel: clss, name: this.userData.name, alert: alrt, response: res, date: currentDateTime}})
        .then(
          (response) => {
            console.log(response.data)
          }
        )
        .catch(
          (error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            }
        )
    }
  },
  mounted() {
    this.lookupUserInfo();
    this.updateUserSessionData();
    this.promoConfirm = this.cookies.get('ClientellPROMO');
    console.log('check cookie '+this.promoConfirm);

    // password reset prompt
    const queryString = window.location.search.substring(1, 11);
    if(queryString === 'reset=true') {
      this.openModal({view: 'UpdatePasswordDialog', dt: ''});
    }

    axios({
        method : 'POST',
        url : '/get_spk',
        data:'',
    })
    .then(
			(response) => {
        // console.log(response.data);
        this.stripePk = response.data;
        this.logEvent({clss: 'success' , alrt: 'Get SPK success', res: response.data})
    })
    .catch(
			(error) => {
        console.log(error);
        this.logEvent({clss: 'fail' , alrt: 'Get SPK failure', res: error.message})
        console.log('form submit failed');
    });
    axios({
      method : 'POST',
      url : '/check_session_status',
      data:'',
      })
    .then(
      (response) => {      
        if(response.data == 'active') {
          this.userStatus = response.data;
          this.logEvent({clss: 'success' , alrt: 'Session Status Active Lookup ', res: response.data})
          this.component = Dashboard;
          // console.log('this status is: ' + this.userStatus);
        } else {
          this.logEvent({clss: 'success' , alrt: 'Session Status Inactive Lookup ', res: response.data})
          this.component = SelectSubscription;
        };
    })
    .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
        this.logEvent({clss: 'fail' , alrt: 'Session Status Inactive Lookup Fail', res: this.errorMessage})
    });
    axios.get('/check_chat')
    .then(
      (response) => {
        // console.log('check chat response '+response.data);
        if(response.data) {
          this.hasChat = true;
          //console.log('Does have chat '+this.hasChat);
          this.getCurrentChat();
        } else {
          //console.log('Does NOT have chat '+this.hasChat);
        }
      }
    )
    .catch(
      (error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      }
    );
    this.configscriptlist();
    this.getfirsttick();
    setInterval(this.onServerSideUpdateTimer, 20000);
  }
}
</script>